<template>
    <v-sheet rounded="circle" color="primary" width="6" height="6" class="realtime-indicator" />
</template>

<style lang="scss">
.realtime-indicator {
    display: inline-block;
    animation: flash linear 3s infinite;
    // fixes alignment issue with text
    margin-top: -1px;
}
</style>
